// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:52:44

export default {
  "id": "elevator-fight",
  "slug": "elevator-fight",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cf5bab9afce444d9bf00b672069e5653-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cf5bab9afce444d9bf00b672069e5653/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Elevator Fight",
      "description": "Make your way to the top floor, one fight at a time. Every level, a new challenger steps in, but only one can ride up! With simple controls and over 130 levels, this game offers quick, close-quarters combat in a cramped elevator. Upgrade your fighter’s speed, power, and defense to keep up with the ever-changing, humorous opponents. What’s waiting at the top?",
      "instructions": "Use WASD or arrow keys on desktop to attack and dodge opponent's hits. On mobile, tap the opponent to attack, tap your fighter to avoid being hit.",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "fighting"
      ]
    },
    "zh-CN": {
      "title": "电梯格斗",
      "description": "逐层上升，一次战斗一次。每个楼层都有一个新挑战者加入，但只有一人能登顶！游戏操作简单，包含超过130个关卡，在狭小的电梯内提供快速、近身战斗。提升你的战斗者的速度、力量和防御力，以应对不断变化、幽默的对手。顶层等待着什么？",
      "instructions": "使用桌面上的WASD键或箭头键攻击和躲避对手的攻击。在手机上，点击对手进行攻击，点击你的角色以躲避攻击。",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "战斗"
      ]
    },
    "zh-TW": {
      "title": "電梯格鬥",
      "description": "一步步通往頂樓，一次只打一場戰鬥。每個關卡都有一個新的挑戰者加入，但只有一個人能夠登上！這款遊戲操作簡單，包含超過130個關卡，在擁擠的電梯中提供快速、近戰的戰鬥。升級戰士的速度、力量和防禦，以應對不斷變化的幽默對手。頂樓等待著什麼呢？",
      "instructions": "使用桌面上的WASD鍵或方向鍵進行攻擊和閃避對手的擊中。在移動裝置上，點擊對手進行攻擊，點擊你的戰士以避免被擊中。",
      "genres": [
        "戰鬥",
        "休閒"
      ],
      "tags": [
        "戰鬥"
      ]
    },
    "zh-HK": {
      "title": "電梯戰鬥",
      "description": "一層一層地上昇，每次只打一場戰鬥。每個關卡都有一個新的挑戰者加入，但只有一個人可以上到頂樓！遊戲控制簡單，超過130個關卡，提供快速的緊密空間戰鬥。升級戰士的速度、力量和防禦力，以應對不斷變化的幽默對手。頂樓等著什麼呢？",
      "instructions": "使用桌面上的WASD或方向鍵攻擊及閃避對手的擊中。在行動裝置上，輕觸對手攻擊，輕觸你的戰士以避免被擊中。",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "戰鬥"
      ]
    },
    "ja": {
      "title": "エレベーターファイト",
      "description": "階段ごとに最上階に進んでください。各レベルで新しい挑戦者が登場しますが、最上階に昇れるのは一人だけです！シンプルな操作と130以上のレベルで、狭いエレベーター内での速やかな近接戦闘が楽しめます。戦士の速度、力、防御をアップグレードして、変わりゆくユーモラスな敵に対応しましょう。最上階には何が待っているのでしょうか？",
      "instructions": "デスクトップではWASDまたは矢印キーを使用して攻撃し、敵の攻撃を避けます。モバイルでは、敵をタップして攻撃し、自分の戦士をタップして攻撃を受けないようにします。",
      "genres": [
        "バトル",
        "カジュアル"
      ],
      "tags": [
        "戦闘"
      ]
    },
    "ko": {
      "title": "엘레베이터 전투",
      "description": "탑층으로 이동하시오, 한 번에 한 대전만. 각 단계마다 새로운 도전자가 나타납니다만, 오르는 건 오직 한 명뿐! 간단한 조종과 130개 이상의 레벨로, 이 게임은 협소한 엘리베이터 안에서 빠르고 가까운 전투를 제공합니다. 전투자의 속도, 힘, 방어력을 강화하여 변화무쌍하고 유머러스한 적들과 맞서 싸워보세요. 탑층에 무엇이 기다리고 있을까요?",
      "instructions": "데스크톱에서 WASD나 방향키를 사용하여 적의 공격을 막고 공격하세요. 모바일에서는 적을 탭하여 공격하고, 자신의 전사를 탭하여 공격을 피하세요.",
      "genres": [
        "전투",
        "캐주얼"
      ],
      "tags": [
        "전투"
      ]
    },
    "fr": {
      "title": "Combat d'ascenseur",
      "description": "Montez jusqu'au dernier étage, combat par combat. À chaque niveau, un nouveau défi se joint à la danse, mais seules une poignée peuvent grimper ! Avec des commandes simples et plus de 130 niveaux, ce jeu propose des combats rapides et intenses dans un ascenseur étroit. Améliorez la vitesse, la puissance et la défense de votre combattant pour suivre les adversaires humoristiques et en perpétuel changement. Qu'y a-t-il au sommet ?",
      "instructions": "Utilisez les touches WASD ou les flèches sur le bureau pour attaquer et esquiver les coups de l'adversaire. Sur mobile, appuyez sur l'adversaire pour attaquer, appuyez sur votre combattant pour éviter d'être touché.",
      "genres": [
        "Bataille",
        "Casual"
      ],
      "tags": [
        "Combattre"
      ]
    }
  }
};
